"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_client_1 = require("apollo-client");
var apollo_link_1 = require("apollo-link");
var apollo_link_error_1 = require("apollo-link-error");
var apollo_link_http_1 = require("apollo-link-http");
var apollo_link_retry_1 = require("apollo-link-retry");
exports.default = (function (_a) {
    var headers = _a.headers, uri = _a.uri;
    var errorLink = (0, apollo_link_error_1.onError)(function (_a) {
        var e_1, _b;
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorHandler = __rest(_a, ["graphQLErrors", "networkError"]);
        console.error(__assign({ graphQLErrors: graphQLErrors, networkError: networkError }, errorHandler));
        if (typeof window.Sentry !== 'undefined') {
            if (graphQLErrors) {
                try {
                    for (var graphQLErrors_1 = __values(graphQLErrors), graphQLErrors_1_1 = graphQLErrors_1.next(); !graphQLErrors_1_1.done; graphQLErrors_1_1 = graphQLErrors_1.next()) {
                        var graphQLError = graphQLErrors_1_1.value;
                        if (window.Sentry)
                            window.Sentry.captureException(graphQLError);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (graphQLErrors_1_1 && !graphQLErrors_1_1.done && (_b = graphQLErrors_1.return)) _b.call(graphQLErrors_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (networkError) {
                if (window.Sentry)
                    window.Sentry.captureException(networkError);
            }
        }
    });
    var httpLink = new apollo_link_http_1.HttpLink({ headers: headers, uri: uri });
    var link = apollo_link_1.ApolloLink.from([new apollo_link_retry_1.RetryLink(), errorLink, httpLink]);
    return new apollo_client_1.ApolloClient({
        cache: new apollo_cache_inmemory_1.InMemoryCache(),
        name: "hb-theme-".concat(process.env.NODE_ENV),
        link: link,
    });
});
